
<div class="home">
  <v-row>
    <v-col cols="12" sm="6">
      <h1 class="display-1">{{ $t("IMAGE_PREVIEW_HEADER") }}</h1>
    </v-col>
    <v-col cols="12" sm="6">
      <v-row justify="end" align="center">
        <v-col class="otherCodeButtonContainer" cols="auto">
          <v-btn @click="back">
            <v-icon dense>add</v-icon>
            {{ $t("BUTTON_OTHER_CODE") }}
          </v-btn>
        </v-col>
        <v-col cols="auto">
          <v-btn class="primary" @click="select">{{ $t("BUTTON_CONTINUE") }}</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
  <br>
  <p class="subheading" v-html="imagePreviewText"></p>
  <v-card v-if="active" class="imageContainer imagePresentation">
    <v-container grid-list-sm fluid>
      <VirtualScroll
          :active="active"
          :initial-items-count="8"
          :preload-padding="getImageHeight()"
          :items="imageSelection.images"
          :visible-window="window"
          class="imageLayout"
          v-masonry
          column-width="137"
          gutter="8"
          transition-duration="0s"
      >
        <template scope="{item, index}">
          <div v-masonry-tile
               :style="{width: getImageWidth(item) + 'px'}"
               :class="{imageSelectionDiv: true, landscape: item.orientation === 'LANDSCAPE', portrait: item.orientation === 'PORTRAIT'}"
          >
            <ImagePreview
                class="imageItem"
                :image="item"
                :small-height="getImageHeight() + 'px'"
                :small-width="getImageWidth(item) + 'px'"
                :ref="`preview-${index}`"
                :hasPreviousPreview="hasPreviousPreview(index)"
                :hasNextPreview="hasNextPreview(index)"
                @openPrevious="openPreview(index-1)"
                @openNext="openPreview(index+1)"
            />
          </div>
        </template>
      </VirtualScroll>
    </v-container>
  </v-card>

  <v-row>
    <v-col cols="12">
      <v-card-actions class="actions">
        <v-spacer/>
        <v-btn class="primary md-raised selectionButton" @click="select">{{ $t("BUTTON_CONTINUE") }}</v-btn>
      </v-card-actions>
    </v-col>
  </v-row>
  <NewsletterDialog/>
</div>
